import { useTranslation } from 'i18n';
import { Typography } from 'ui';

import { guideImages } from '../../data';
import { GuideImage } from '../GuideImage/GuideImage';

export const PartFour = () => {
  const { t } = useTranslation('features');

  return (
    <>
      <GuideImage src={guideImages.clearPile} alt={t('backlog.helpGuides.aiLoose.partFour.imageAlt')} height="fixed" />
      <Typography>
        <Typography component="span" fontWeight="bold">
          {t('backlog.helpGuides.aiLoose.partFour.clearPile')}&nbsp;
        </Typography>
        {t('backlog.helpGuides.aiLoose.partFour.and')}&nbsp;
        <Typography component="span" fontWeight="bold">
          {t('backlog.helpGuides.aiLoose.partFour.repeatSteps')}&nbsp;
        </Typography>
        {t('backlog.helpGuides.aiLoose.partFour.untilText')}
      </Typography>
    </>
  );
};
